import { cx } from './cx'

/**
 * A placeholder bar while data loads: --surface-page, radius 4, a slow pulse (still with
 * reduced motion). Not in Figma. Decorative: the region that loads says so (aria-busy).
 */
export function Skeleton({ width, height = 14, className }: { width?: number | string; height?: number; className?: string }) {
    return (
        <span
            aria-hidden
            className={cx('block max-w-full animate-pulse rounded-[4px] bg-[var(--surface-page)] motion-reduce:animate-none', className)}
            style={{ width: width ?? '100%', height }}
        />
    )
}
